import { createTrackedItemsStore } from '../tracked-items'
import { log } from '@/services/log'

log('ᛋᛣᚢᚢᛚᛞ Loading assets.js...')
const createInitialFilterState = () => {
  return {
    selectedCategories: [],
    selectedLocations: [],
    selectedSites: [],
    startTimestamp: null,
    endTimestamp: null,
    period: null,
  }
}
const storeId = 'jobs'
export const useJobStore = createTrackedItemsStore(
  storeId,
  {
    templateName: storeId,
    type: 'Job',
    pageHeading: 'Jobs',
    noHistory: true,
    sortingOn: 'toolbar',
    statusesFilterName: 'statuses',
    uri: '/jobs',
    serviceUri: '/jobs',
    listingModuleName: 'Jobs',
    listingActivityName: 'View Jobs',
    formModuleName: 'Assets',
    formActivityName: 'Edit Job',
    allFields: [
      {
        key: 'name',
        title: 'Name',
        sortable: true,
        visible: true,
        disabled: false,
      },
      {
        key: 'parent',
        title: 'PARENT',
        type: 'parent',
        sortable: true,
        visible: true,
        disabled: false,
      },
      {
        key: 'auditCategories',
        title: 'AUDIT CATEGORY',
        type: 'auditCategorgies',
        visible: true,
        sortable: true,
        disabled: false,
      },
      {
        key: 'allocatedReadZone',
        title: 'ALLOCATED LOCATION',
        type: 'readZone',
        sortable: true,
        visible: true,
        disabled: false,
      },
      {
        key: 'currentReadZone',
        title: 'CURRENT LOCATION',
        type: 'readZone',
        visible: true,
        sortable: true,
        disabled: false,
      },
      {
        key: 'serialNumber',
        title: 'SERIAL NUMBER',
        visible: true,
        sortable: true,
        disabled: false,
      },
      {
        key: 'tags',
        title: 'RFID',
        type: 'tags',
        visible: true,
        sortable: true,
        disabled: false,
      },
      {
        key: 'category',
        title: 'CATEGORY',
        type: 'category',
        visible: true,
        sortable: true,
        disabled: false,
      },
      {
        key: 'description',
        title: 'DESCRIPTION',
        visible: true,
        sortable: true,
        disabled: false,
      },
      {
        key: 'lastTimestamp',
        title: 'LAST SCANNED TIME',
        type: 'micros',
        sortable: true,
        visible: true,
        disabled: false,
      },
      {
        key: 'firstTimestamp',
        title: 'FIRST SCANNED TIME',
        type: 'micros',
        sortable: true,
        visible: false,
        disabled: false,
      },
      {
        key: 'itemType',
        title: 'TYPE',
        visible: false,
        sortable: false,
        disabled: false,
      },
      {
        key: 'externalId',
        title: 'UUID',
        visible: false,
        sortable: false,
        disabled: false,
      },
      {
        key: 'createdBy',
        title: 'CREATED BY',
        visible: false,
        sortable: true,
        disabled: false,
      },
      {
        key: 'createdTimestamp',
        title: 'CREATED TIME',
        type: 'datetime',
        visible: false,
        sortable: true,
        disabled: false,
      },
      {
        key: 'lastModifiedBy',
        title: 'LAST MODIFIED BY',
        visible: false,
        sortable: true,
        disabled: false,
      },
      {
        key: 'lastModifiedTimestamp',
        title: 'LAST MODIFIED TIME',
        type: 'datetime',
        visible: false,
        sortable: true,
        disabled: false,
      },
      {
        key: 'status',
        title: 'STATUS',
        visible: false,
        sortable: true,
        disabled: false,
      },
      {
        key: 'actions',
        title: 'ACTIONS',
        visible: true,
        disabled: true,
        sortable: false,
      },
    ],
    apiColumnsMapping: {
      name: ['name', 'alias'],
      serialNumber: ['serialnumber', 'serial number', 'serial no', 'serial', 'serial #'],
      description: ['description', 'desc', 'info'],
      categoryName: ['categoryName', 'category Name'],
      rfid: ['tags', 'tag', 'rfid', 'rfid tag', 'rfid tags', 'tag id', 'tag ids', 'epc', 'epcs'],
      locationName: [
        'allocated readzone name',
        'allocated readzone',
        'allocated location',
        'location',
        'location name',
        'readzone',
        'read zone',
      ],
      auditCategoriesCsv: ['audit categories', 'categories'],
    },
  },
  {
    supportedPageFilters: {
      periodApplicable: 'false',
      selectedSites: { type: 'sites' },
      selectedCategories: {
        type: 'categories',
        multiple: true,
        optionsLabel: 'name',
        submitValueKey: 'externalId',
        serviceUri: '/categories/selfAndBelow/Assets',
        dxTableName: '',
      },
      selectedLocations: {
        type: 'readzones',
        placeholder: 'Pick one or more locations to filter',
        label: 'Location(s)',
      },
    },
    filters: createInitialFilterState(),
  },
  {
    resetPageFilters() {
      const store = useJobStore()
      store.filters = createInitialFilterState()
      store.supportedPageFilters.periodApplicable = 'false'
      store.resetBaseFilters()
    },
    copy(item) {
      const obj = {
          name: item.name,
          description: item.description,
          serialNumber: item.serialNumber,
          category: item.category,
          auditCategories: item.auditCategories,
          parent: item.parent,
          allocatedReadZone: item.allocatedReadZone,
      }
      return obj
    },
  },
  {
    fields: [
      {
        id: 'job_name',
        name: 'name',
        label: 'Name',
        size: 6,
        component: 'NInput',
        componentProps: { placeholder: 'Pick a name', optionsAlias: 'ItemNames' },
        rules: [
          {
            required: false,
            trigger: ['blur', 'input'],
          },
        ],
      },
      {
        id: 'job_category',
        name: 'category',
        label: 'Category',
        size: 6,
        component: 'CategorySingleSelect',
        componentProps: {
          multiple: false,
          placeholder: 'Pick a category',
          serviceUri: '/categories/selfAndBelow/Jobs',
          optionsLabel: 'name',
          submitValueKey: 'externalId',
        },
        rules: [
          {
            required: false,
            trigger: ['blur', 'input'],
          },
        ],
      },
      {
        id: 'job_parent',
        name: 'parent',
        label: 'Parent Job',
        size: 6,
        component: 'ArsSmartSelect',
        componentProps: {
          multiple: false,
          placeholder: 'Pick a location',
          dxTableName: 'Jobs',
          serviceUri: '/jobs',
          optionsLabel: 'name',
          submitValueKey: 'externalId',
        },
        rules: [
          {
            required: false,
            trigger: ['blur', 'input'],
          },
        ],
      },
      {
        id: 'job_audit_categories',
        name: 'auditCategories',
        label: 'Audit Categories',
        size: 6,
        component: 'PickList',
        componentProps: { placeholder: 'Select an audit category', optionsAlias: 'AuditCategory', multiple: true },
        rules: [
          {
            required: false,
            type: 'array',
            trigger: ['blur', 'input'],
          },
        ],
      },
      {
        id: 'job_serial_number',
        name: 'serialNumber',
        label: 'Serial Number',
        size: 6,
        component: 'NInput',
        componentProps: { placeholder: 'Enter a serial number' },
        rules: [
          {
            required: false,
            trigger: ['blur', 'input'],
          },
          {
            trigger: 'blur',
            remoteValidator: 'isjobSerialNumberUnique',
          },
        ],
      },
      {
        id: 'job_allocated_location',
        name: 'allocatedReadZone',
        label: 'Location',
        size: 6,
        component: 'ArsSmartSelect',
        componentProps: {
          multiple: false,
          placeholder: 'Pick a location',
          dxTableName: 'Readzones',
          serviceUri: '/readzones',
          optionsLabel: 'name',
          submitValueKey: 'externalId',
        },
        rules: [
          {
            required: false,
            trigger: ['blur', 'input'],
          },
        ],
      },
      {
        id: 'job_tags',
        name: 'tags',
        label: 'RFID',
        size: 6,
        component: 'ArsTagSelect',
        componentProps: {
          multiple: true,
          filterable: true,
          placeholder: 'Add a tag',
        },
        rules: [
          {
            required: false,
            type: 'array',
            customValidator: 'isValidTag',
            trigger: 'blur',
          },
          {
            trigger: 'blur',
            remoteValidator: 'isRfidUnique',
          },
        ],
      },
      {
        id: 'job_description',
        name: 'description',
        label: 'Description',
        size: 24,
        component: 'NInput',
        componentProps: { placeholder: 'Enter a description' },
        rules: [
          {
            required: false,
            trigger: ['blur', 'input'],
          },
        ],
      },
    ],
  }
)
